import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';


function Test_Ms_AdmissionELe() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Admissionleft activeIndex={1} />
                    </Col>

                    <Col md={8} className='c-right'>
                        <div className="c-heading">
                            <h3>M.S. (Research)</h3> <br />
                        </div>
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Guidelines
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}>
                                    Categories
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}>
                                    Areas
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setEligiblityOpen)}
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}>
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setFinancialOpen)}
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}>
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}>
                                    Selection
                                </Button>
                            </Col>
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setDocumentsOpen)}
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}>
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}>
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setApplyonlineOpen)}
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}>
                                    Apply Online
                                </Button>
                            </Col>



                        </Row>


                        {/*dates */}
                        <div>
                            {datesOpen && <Fade in={datesOpen}>
                                <div>
                                    {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for M.S. (R)  on July 25-26, 2024 - {" "}
                            <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}

                                    {/* <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" />
                                    <a className='text-maroon' href="https://files.iittp.ac.in/pdfs/admissions/2024/MS_PhD_July_2024_Flyer.pdf" target="_blank;"><b> M.S.(R) Admissions for July-2024 Brochure - Click here</b></a> */}

                                    <p className="fw-bold caboutus">	
                                        <span className="glowing-text">
                                            Shortlisted Candidates List for the M.S.(R) January 2027 cycle - 
                                            <Link className="c-link" to="https://iittp.ac.in/msphd-admissions" >Click here</Link>
                                        </span>
                                    </p>
                                    <p className="fw-bold caboutus">
                                        <span className="glowing-text">
                                            Syllabus for Written test and Interview of M.S.(R) January 2027 cycle - 
                                            <Link className="c-link" to="https://iittp.ac.in/msphd-admissions" >Click here</Link>
                                        </span>
                                    </p>

                                    <Table bordered responsive className='mt-3'>
                                        <thead>
                                            <tr>
                                                <th colSpan="2" className="text-center">
                                                    <h4 className="text-primary">Important Dates</h4>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Opening date and time for online application</td>
                                                <td>21 September 2026 (Monday) at 11:00 AM</td>
                                            </tr>
                                            <tr>
                                                <td>Closing date and time for online application</td>
                                                <td>12 October 2026 (Monday) upto 05:00 PM</td>
                                            </tr>
                                            <tr>
                                                <td>Written Test / Interview</td>
                                                {/* <td><b className="c-link glowing-text">Will be updated soon..</b></td> */}
                                                <td><b className="c-link glowing-text">To be Announced </b></td>
                                            </tr>
                                            <tr>
                                                <td>Announcement of Results</td>
                                                {/* <td><b className="c-link glowing-text">Will be updated soon..</b></td> */}
                                                <td><b className="c-link glowing-text">To be Announced</b></td>
                                            </tr>
                                            <tr>
                                                <td>Reporting to Campus</td>
                                                <td><b className="c-link glowing-text">To be Announced</b></td>
                                                {/* <td><b>From 29th November 2025 (Saturday)</b></td> */}
                                            </tr>
                                            <tr>
                                                <td>Date of Orientation Program</td>
                                                <td><b className="c-link glowing-text">To be Announced</b></td>
                                                {/* <td><b>	Monday, 1st December 2025</b></td> */}
                                            </tr>

                                            {/* <tr>
                                                                               <td>Commencement of classes</td>
                                                                               <td><b>Thursday, August 1, 2024</b></td>
                                                                           </tr> */}

                                        </tbody>
                                    </Table>

                                    <b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link>  or call 0877 250 3532 for  any questions or queries regarding admission related matters. </b>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h4 className="mb-3">Important Guidelines</h4>
                                    <ol style={{ textAlign: 'justify', fontSize: '12pt' }} className="caboutus">
                                        <li>
                                            1) The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
                                        </li>
                                        <li>
                                            2) The application fee is as follows:
                                            <ul className='myulcustarrow'>
                                                <li>
                                                    GEN/EWS/OBC-NCL Male candidates: Rs.400/-
                                                </li>
                                                <li>
                                                    GEN/EWS/OBC-NCL Female candidates: Rs.200/-
                                                </li>
                                                <li>
                                                    SC/ST and PwD candidates: Rs.200/-
                                                </li>
                                            </ul>
                                            <p style={{ color: '#2009df' }}>The application fee is non-refundable. Please ensure to save the payment reference number.</p>
                                        </li>
                                        <li>
                                            3) A candidate can apply to more than one division among all departments; however, the maximum number of divisions to which he or she can apply is three.
                                        </li>
                                        <li>
                                            4) Candidates called for the written test/interview must produce a copy of the application submitted online along with originals and photocopies of the relevant certificates.
                                        </li>
                                        <li>
                                            5) Reservation/concession/relaxations for EWS/OBC-NCL/SC/ST/PwD and Kashmiri- Migrants (KM), including Kashmiri Pandits/Kashmiri Hindu Families: As per the Government of India rules. A copy of a valid OBC-NCL/ST/SC/EWS/PwD certificate must be uploaded during the ONLINE application and must be submitted at the time of admission.
                                        </li>
                                        <li>
                                            6) A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this <a href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx" target="_blank" rel="noopener noreferrer">Link</a>.
                                        </li>
                                        <li>
                                            7) At the time of physical reporting to the Institute, candidates must submit self-attested copies of the relevant certificates as specified in the Documents tab, failing which admission will stand cancelled.
                                        </li>
                                        <li>
                                            8) Please make all files ready with the following format and size before going to file upload:
                                            <ul className='myulcustarrow'>
                                                <li> Passport size Photo (jpg, jpeg, png), size &lt;=500 KB</li>
                                                <li> Signature (format jpg, jpeg, png) size &lt;= 200 KB</li>
                                                <li> 10th Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> 12th / Diploma / Equivalent Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Qualifying UG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Consolidated UG mark sheet (pdf) size &lt;=1024 KB</li>
                                                <li> Qualifying PG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Consolidated PG mark sheet (pdf) size &lt;=1024 KB</li>
                                                <li> Community Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                <li> PwD Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                <li> Applicable National Level Exams/GATE (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                <li> SoP/Research Proposal, (pdf) size &lt;=1024 KB</li>
                                                <li> First page of publication, if applicable (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                            </ul>
                                            <p><b>Additional documents for external/part-time/internal category candidates</b></p>
                                            <ul className='myulcustarrow caboutus'>
                                                <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                <li> No-Objection Certificate or Undertaking
                                                    <ul className='myulcustarrow'>
                                                        <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                        <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>
                                        <li>
                                            9) Please visit the institute’s website regularly for important announcements and results.
                                        </li>
                                        <li>
                                            10) In case of any queries, please write to{' '}
                                            <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877-250 3532 (9.00 AM to 5.30 PM on all working days).
                                        </li>
                                    </ol>

                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Categoies*/}

                        <div>
                            {categoryOpen && <Fade in={categoryOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h5 className="mb-3">M.S.(Research) admissions are made under various modes of HTRA (Half Time Research Assistantship) and Non-HTRA categories as mentioned below:</h5>

                                    <h5 className='me-3 mt-3'>HTRA Category: </h5>
                                    <ul className="caboutus">
                                        <li>
                                            <b>  1. Regular (Full-time scholars): </b> The research scholars selected under regular registration will be eligible for assistantship through various schemes (please see Financial Assistance)
                                        </li>
                                        <li>
                                            <b>  2. Regular-Fellowship:</b> Scholars funded by outside agencies such as UGC, CSIR, PMRF, etc.
                                        </li>
                                    </ul>
                                    <h5 className='me-3 mt-3'>Non-HTRA Category:</h5>
                                    <ul className="caboutus">
                                        <li>
                                            <b>  1. External: </b>
                                            <ul className='myulcustarrow caboutus'>


                                                <li> The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST or by IIT Tirupati.</li>
                                                <li> Research scholars admitted under this category will normally carry out part or all of their research in the parent organization under supervision of a faculty from IIT Tirupati and a co-supervisor employed in their parent organization.</li>

                                                <li> The following documents are required along with the application
                                                    <ul className='myulcustarrow caboutus'>
                                                        <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                        <li> No-Objection Certificate or Undertaking
                                                            <ul className='myulcustarrow'>
                                                                <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                                <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            </ul>
                                                        </li>
                                                    </ul>

                                                </li>

                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow caboutus'>
                                                        <li>Certificate of Support from the Employer</li>
                                                        <li>Relieving Certificate from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</Link></li>
                                                    </ul>
                                                </li>

                                            </ul>
                                        </li>
                                    </ul>
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    <ul>
                                        <li>
                                            <b>  2. Part-Time: </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                                <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>

                                                <p>Note: The minimum residential requirement for the M.S. research scholars under External registration and M.S. research scholars under Part-time registration is one semester.</p>

                                                <li> The following documents are required at the time of application
                                                    <ul className='myulcustarrow caboutus'>
                                                        <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                        <li> No-Objection Certificate or Undertaking
                                                            <ul className='myulcustarrow caboutus'>
                                                                <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                                <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow caboutus'>
                                                        <li>Relieving (Leave) Certificate from the Employer: <a className='c-link' href="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;">Link</a></li>
                                                    </ul>
                                                </li>
                                            </ul>

                                        </li>
                                    </ul>
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    <ul>
                                        <li>
                                            <b>  3. Internal (IIT Tirupati Staff): </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> The applicant must be regular employee of IIT Tirupati.</li>
                                                <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                                <li><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <b>  4. M.S.(R) through Project – Without National Level Examination (IITT Project Staff): </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> The eligible candidates who have already been working with a project administered by Centre for Sponsored Research and Consultancy (CSRC) at IITT can apply for the M.S.(Research).</li>
                                                <li> The applicant should have at least two months of experience in the project at IIT Tirupati as on the last date of receipt of applications.</li>

                                            </ul>
                                        </li>
                                    </ul>


                                    <ul>
                                        <li>
                                            <b> Note: </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> (i) The minimum residential requirement for the M.S. research scholars under External/Part-time category of admission is one semester.</li>
                                                <li> (ii) Candidates admitted under Non-HTRA category cannot be moved to HTRA category at a later date.</li>
                                                <li> (iii) More details on External/Part-time category of admission, including any questions regarding the recognition of the organization/laboratory might be addressed to the Head of the department of interest or <Link to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> </li>
                                            </ul>
                                        </li>
                                    </ul>

                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Areas*/}

                        <div>
                            {areasOpen && <Fade in={areasOpen}>
                                <div>
                                    <h4 className='mb-4'>Research Areas</h4>
                                    {/*<p class="caboutus">
                                        Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. </p>
                                    <p className='caboutus'><b>The available research areas for July 2026 admission cycle are tabulated below. SoP is mandatory for Chemical Engineering, Computer Science and Engineering, Electrical Engineering, and Mechanical Engineening: <a className='c-link' href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf" target="_blank"> Click here for SoP template</a></b>
                                    </p>
                                    <p class="caboutus"><b>Note:</b> The research areas marked with asterisk(*) are available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</p>*/}
                                    {/* Table */}


                                    {/* <p><em>*These research areas available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</em></p> */}
                                

<p>
    Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. The available research areas for January 2027 admission cycle are tabulated below.
</p>

<p>
    SoP is mandatory for all departments.{' '}
    <a
        href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf"
        target="_blank"
        rel="noreferrer"
    >
        Click here for SoP template
    </a>
</p>

<p>
    <b>Note:</b> The research areas marked with asterisk(*) are available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.
</p>

<Table bordered responsive className='mt-3 c-table'>

    <colgroup>
        <col style={{ width: '18%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '37%' }} />
        <col style={{ width: '25%' }} />
    </colgroup>

    <tbody>

        {/* Header */}
        <tr>
            <td><b>Department</b></td>
            <td><b>Division</b></td>
            <td><b>Areas of Research</b></td>
            <td><b>Additional Information</b></td>
        </tr>


        {/* Chemical Engineering */}
        <tr>
            <td rowSpan='27'>Chemical Engineering</td>
            <td rowSpan='27'>Chemical Engineering</td>
            <td>Hydrogen Fuel Cell Characterization</td>
            <td></td>
        </tr>

        <tr>
            <td>Critical minerals Recovery - Molecular Dynamics study</td>
            <td></td>
        </tr>

        <tr>
            <td>Electrocatalysis for green hydrogen and fuels</td>
            <td></td>
        </tr>

        <tr>
            <td>Sodium ion battery materials</td>
            <td></td>
        </tr>

        <tr>
            <td>Recycling of spent Li-ion batteries</td>
            <td></td>
        </tr>

        <tr>
            <td>Catalytic conversion of CO2</td>
            <td></td>
        </tr>

        <tr>
            <td>Solar cells</td>
            <td></td>
        </tr>

        <tr>
            <td>Wearbale biosensors/bimedical devices</td>
            <td></td>
        </tr>

        <tr>
            <td>Solid state battery and interface</td>
            <td></td>
        </tr>

        <tr>
            <td>Computer vision for healthcare diagnostics</td>
            <td></td>
        </tr>

        <tr>
            <td>Microfluidics</td>
            <td></td>
        </tr>

        <tr>
            <td>Biomass to chemicals</td>
            <td></td>
        </tr>

        <tr>
            <td>Bioactive Extraction for Food</td>
            <td></td>
        </tr>

        <tr>
            <td>Critical minerals Recovery - Experimental study</td>
            <td></td>
        </tr>

        <tr>
            <td>Computationally engineered materials</td>
            <td></td>
        </tr>

        <tr>
            <td>Molecular simulations</td>
            <td></td>
        </tr>

        <tr>
            <td>Materials for gas capture</td>
            <td></td>
        </tr>

        <tr>
            <td>Green hydrogen supply chain optimization</td>
            <td></td>
        </tr>

        <tr>
            <td>Intelligent Control</td>
            <td></td>
        </tr>

        <tr>
            <td>Sustianable energy systems modeling</td>
            <td></td>
        </tr>

        <tr>
            <td>Reinforcement learning for vehicle routing</td>
            <td></td>
        </tr>

        <tr>
            <td>ML/AI for climate modeling and weather forecasting</td>
            <td></td>
        </tr>

        <tr>
            <td>Complex networks for process analysis and process monitoring</td>
            <td></td>
        </tr>

        <tr>
            <td>Non-linear identification and state estimation</td>
            <td></td>
        </tr>

        <tr>
            <td>Circular economy</td>
            <td></td>
        </tr>

        <tr>
            <td>ML for CO2 capture</td>
            <td></td>
        </tr>

        <tr>
            <td>AI/ML for adsorbent materials</td>
            <td></td>
        </tr>


        {/* Civil & Environmental Engineering */}
        <tr>
            <td rowSpan='13'>Civil &amp; Environmental Engineering</td>
            <td rowSpan='5'>Environmental Engineering</td>
            <td>Air Quality Modelling and Management</td>
            <td></td>
        </tr>

        <tr>
            <td>Life Cycle and Sustainability Assessment</td>
            <td></td>
        </tr>

        <tr>
            <td>Advanced Water and Wastewater Treatment</td>
            <td>Environmental Engineering</td>
        </tr>

        <tr>
            <td>Applications of Non-Thermal Plasma in Agriculture and Food Crop Management</td>
            <td>Environmental Engineering</td>
        </tr>

        <tr>
            <td>Capacitive Deionization for Water Desalination</td>
            <td>Environmental Engineering</td>
        </tr>

        <tr>
            <td rowSpan='2'>Geotechnical Engineering</td>
            <td>All areas of Geotechnical Engineering</td>
            <td>Geotechnical Engineering</td>
        </tr>

        <tr>
            <td>Rock Engineering</td>
            <td>Geotechnical or Rock Mechanics</td>
        </tr>

        <tr>
            <td rowSpan='2'>Structural Engineering</td>
            <td>All areas of Structural Engineering</td>
            <td></td>
        </tr>

        <tr>
            <td>Construction Materials</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='2'>Transportation Engineering</td>
            <td>Pavement Technology</td>
            <td></td>
        </tr>

        <tr>
            <td>Freight Demand Modelling</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='2'>Water Resources Engineering</td>
            <td>Flood modeling, Digital Twin</td>
            <td>GIS, Remote Sensing</td>
        </tr>

        <tr>
            <td>Water Resources Management</td>
            <td>GIS, Remote Sensing</td>
        </tr>


        {/* Computer Science and Engineering */}
        <tr>
            <td rowSpan='10'>Computer Science and Engineering</td>
            <td rowSpan='3'>Computer Systems</td>
            <td>AI Accelerator and Semiconductor Test</td>
            <td></td>
        </tr>

        <tr>
            <td>Computer Vision</td>
            <td></td>
        </tr>

        <tr>
            <td>Quantum System Architecture</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='4'>Intelligent Systems</td>
            <td>Software Engineering and AI</td>
            <td></td>
        </tr>

        <tr>
            <td>Malware Analysis and AI for Cybersecurity</td>
            <td></td>
        </tr>

        <tr>
            <td>Deep Learning for Medical Imaging</td>
            <td></td>
        </tr>

        <tr>
            <td>ML for IOT</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>Algorithms and Theory</td>
            <td>Algorithms and complexity , Quantum Computing</td>
            <td></td>
        </tr>

        <tr>
            <td>Secure Data Analytics</td>
            <td></td>
        </tr>

        <tr>
            <td>Algorithms, Data Structures and Parallel Computing</td>
            <td></td>
        </tr>


        {/* Electrical Engineering */}
        <tr>
            <td rowSpan='13'>Electrical Engineering</td>
            <td rowSpan='3'>Power and Control</td>
            <td>Power Electronics</td>
            <td></td>
        </tr>

        <tr>
            <td>Control, Optimization, and Robotics</td>
            <td></td>
        </tr>

        <tr>
            <td>Power Systems and Smart Grids</td>
            <td></td>
        </tr>

        <tr>
            <td>Semiconductor Devices</td>
            <td>Semiconductor Devices</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>VLSI</td>
            <td>Harsh Environment Electronics and Sensors</td>
            <td>
                For MS, valid GATE score is required, EC/EE/IN/CS/Similar Disciplines can apply.
            </td>
        </tr>

        <tr>
            <td>Digital VLSI Design</td>
            <td>
                For MS, valid GATE score is required, EC/CS/Similar Disciplines can apply.
            </td>
        </tr>

        <tr>
            <td>Analog VLSI Design</td>
            <td>
                For MS, valid GATE score is required, EC/EE/IN/CS/Similar Disciplines can apply.
            </td>
        </tr>

        <tr>
            <td rowSpan='4'>RF and Microwaves</td>
            <td>Advanced Antenna Systems and Base Station</td>
            <td>
                For the MS program in the RF &amp; Microwave stream, eligible applicants include those with a valid GATE score in EE, EC, IN, PH OR valid UGC/CSIR-NET score in Electronic Science.
            </td>
        </tr>

        <tr>
            <td>RF and Microwave Components</td>
            <td>
                For the MS program in the RF &amp; Microwave stream, eligible applicants include those with a valid GATE score in EE, EC, IN, PH OR valid UGC/CSIR-NET score in Electronic Science.
            </td>
        </tr>

        <tr>
            <td>RF Integrated Circuits</td>
            <td>
                For the MS program in the RF &amp; Microwave stream, eligible applicants include those with a valid GATE score in EE, EC, IN, PH OR valid UGC/CSIR-NET score in Electronic Science.
            </td>
        </tr>

        <tr>
            <td>Metamaterials and RF Sensing</td>
            <td>
                For the MS program in the RF &amp; Microwave stream, eligible applicants include those with a valid GATE score in EE, EC, IN, PH OR valid UGC/CSIR-NET score in Electronic Science.
            </td>
        </tr>

        <tr>
            <td rowSpan='2'>Next-Generation Wireless Communications and Networks</td>
            <td>Communication Networks</td>
            <td>
                For the MS program in the Next-Generation Wireless Communications and Networks stream, students with a valid GATE score in EE, EC and PH are enciuraged to apply.
            </td>
        </tr>

        <tr>
            <td>Quantum Information Theory</td>
            <td>
                For the MS program in the Next-Generation Wireless Communications and Networks stream, students with a valid GATE score in EE, EC and PH are enciuraged to apply.
            </td>
        </tr>


        {/* Mechanical Engineering */}
        <tr>
            <td rowSpan='16'>Mechanical Engineering</td>
            <td rowSpan='6'>Advanced Manufacturing</td>
            <td>Piezoelectric thin films</td>
            <td></td>
        </tr>

        <tr>
            <td>Multiferroic materials</td>
            <td></td>
        </tr>

        <tr>
            <td>Self-Healing Composite Materials and Non Destructive Testing (NDT)</td>
            <td></td>
        </tr>

        <tr>
            <td>Semiconductors and High-performance computing thermal Management Architectures</td>
            <td></td>
        </tr>

        <tr>
            <td>Smart manufacturing platform for the Hybrid Metal Additive Manufacturing process</td>
            <td></td>
        </tr>

        <tr>
            <td>
                Shape-Agnostic Machine Learning-Based Prediction and Optimization of Thermal Evolution, Cooling Rates, and Distortion in Metal Additive Manufacturing
            </td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='7'>Fluids &amp; Thermal Engineering</td>
            <td>Hydrogen storage, Hydrogen combustion</td>
            <td></td>
        </tr>

        <tr>
            <td>Multiphase flows, CFD</td>
            <td></td>
        </tr>

        <tr>
            <td>Liquid Atomization and Sprays</td>
            <td></td>
        </tr>

        <tr>
            <td>Drones, wind turbine aerodynamics, CFD, low speed flows, wind tunnel experiments</td>
            <td></td>
        </tr>

        <tr>
            <td>Fluid-structure interaction</td>
            <td></td>
        </tr>

        <tr>
            <td>Hydrogen storage, Thermal energy storage, Absorption cooling</td>
            <td></td>
        </tr>

        <tr>
            <td>Water Waves: Experiments, Mathematical Modeling, and CFD</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>Solid Mechanics &amp; Design</td>
            <td>Automotive dynamics, vibrations, vibro-acoustics</td>
            <td></td>
        </tr>

        <tr>
            <td>
                Computational solid mechanics, continuum mechanics, plasticity, phase transformations, machine learning in mechanics
            </td>
            <td>Solid Mechanics and Design</td>
        </tr>

        <tr>
            <td>Biomechanics, Medical Devices, Solid Mechanics, Finite Element Analysis</td>
            <td>Solid Mechanics and Design</td>
        </tr>

    </tbody>
</Table>
                                </div>
                            </Fade>
                            }
                        </div>



                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && <Fade in={eligiblityOpen}>
                                <div>
                                    <h4 className='mb-4'>Eligibility</h4>
                                    <h5 className='mb-4'>Candidates seeking admission to the M.S. (R) program are required to meet the following minimum eligibility criteria:</h5>
                                    <ul className='myulcustarrow caboutus'>
                                        <li>
                                            Candidates with a Bachelor's degree in Engineering/Technology/4-year BS degree, or a Master’s degree (M.Sc./MCA, etc.) in the relevant discipline with a valid GATE score are eligible to apply. Candidates with a four-year relevant (online) Bachelor’s degree from a recognized university and a valid GATE score are also eligible to apply for the M.S. (Research) programme at IIT Tirupati.
                                        </li>
                                        <div className='text-center mb-2'> (or) </div>
                                        <li>
                                            Candidates with Associate membership and have passed both part A and part B of the examination of professional bodies such as The Institution of Engineers (India) (Civil/Mechanical/Electrical and Electronics/Electronics and communications), The Institute of Electronics and Tele-Communication Engineering with a good academic record and valid GATE score
                                        </li>
                                        <div className='text-center mb-2'> (or) </div>
                                        <li>
                                            Candidates with a Bachelor’s degree in Engineering/Technology from any Indian Institute of Technology (IITs) with an exceptionally good academic record in an eligible discipline and a minimum CGPA of 8/10 (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                        </li>

                                    </ul>
                                    <span className='text-info caboutus'>Note: A valid GATE score is not required in the case of candidates applying under the external/part-time/internal category.  </span>


                                    <h5 className='mt-3 mb-3'>In addition, applicants under External/Part-Time/Internal category have to satisfy the following criteria:</h5>


                                    <h5 className='mt-3 mb-3'> External:</h5>

                                    <ul className='myulcustarrow caboutus'>
                                        <li>The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                        <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST/DSIR or having an MoU with IIT Tirupati.</li>
                                    </ul>

                                    <h5 className='mt-3 mb-3'>Part-Time:</h5>

                                    <ul className='myulcustarrow caboutus'>
                                        <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                        <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
                                    </ul>

                                    <h5 className='mt-3 mb-3'>Internal (IIT Tirupati Staff):</h5>
                                    <ul className='myulcustarrow caboutus'>
                                        <li> The applicant must be regular employees of IIT Tirupati.</li>
                                        <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                    </ul>
                                    <h5 className='mt-3 mb-3'>M.S.(R) through Project – Without National Level Examination (IITT Project Staff):</h5>
                                    <ul className='myulcustarrow caboutus'>
                                        <li> The applicant must be working on any project administered by the Centre for Sponsored Research and Consultancy (CSRC) at IIT Tirupati.</li>
                                        <li> The applicant should have at least two months of experience in the project at IIT Tirupati as on the last date of receipt of applications.</li>
                                    </ul>
                                    <p className='caboutus'><b>Note: A valid GATE score is not required in the case of candidates applying under the External/Internal/Part-Time/IITT-Project category.</b></p>
                                </div>

                            </Fade>
                            }
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && <Fade in={financialOpen}>
                                <div>
                                    <h4 className='mb-4'>Financial Assistance</h4>
                                    <p className='caboutus'>
                                        Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
                                    </p>
                                    <ul className='myulcustarrow caboutus'>
                                        <li>
                                            They should work for 8 hours per week for the Institute to earn this assistantship. The work would normally involve assistance in teaching/research and will be assigned by the Institute.
                                        </li>
                                        <li>
                                            Renewal of assistantship every semester will be contingent on enrolment, satisfactory progress in research work and good performance during the preceding semester in the discharge of responsibility as teaching/ research assistant.
                                        </li>
                                        <li>
                                            Assistantship for candidates who have qualified through UGC-JRF, CSIR-JRF, ICMR & AICTE etc. will be as per the norms of the funding agency.
                                        </li>
                                    </ul>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Section*/}

                        <div>
                            {sectionOpen && <Fade in={sectionOpen}>
                                <div>
                                    <h4 className='mb-4'>Selection Procedure</h4>
                                    <p className='caboutus'>The selection committee will call eligible candidates based on the minimum eligibility requirements and additional screening criteria for a written test (if any) and interview.</p>
                                </div>
                            </Fade>}
                        </div>


                        {/*Documents*/}

                        <div>
                            {documentsOpen && <Fade in={documentsOpen}>
                                <div>
                                    <h4 className='mb-4'>Original Documents to be submitted for Verification:</h4>
                                    <p>
                                        <b>At the time of Interview and/or Written Test:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of interview and/or written test.</p>
                                    <ul className='myulcustarrow caboutus'>
                                        <li>
                                            Copy of application
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                            Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                        </li>
                                        <li>
                                            Copy of valid GATE score (if applicable)
                                        </li>
                                        <li>
                                            Candidates applying under External Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                            Candidates applying under Part-Time Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                            Candidates applying under Internal Category must produce : No Objection Certificate
                                        </li>

                                    </ul>
                                    <p className='text-teal'>
                                        Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                    <p>
                                        <b>At the time of Admission:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of admission / registration</p>
                                    <ul className='myulcustarrow caboutus'>
                                        <li>
                                            Offer of admission.
                                        </li>
                                        <li>
                                            Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                        </li>
                                        <li>
                                            Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc.
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Candidates admitted under External category must also produce:
                                            <ol className='ms-3 caboutus'>
                                                <li>
                                                    No Objection Certificate for using Research Facilities on the employer’s premises. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                    Consent of Co-supervisor from the parent organization in case of external candidates. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Co-Supervisor_Particulars.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                    Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>

                                            </ol>
                                        </li>

                                        Candidates admitted under Part-Time category must also produce:
                                        <ol className='ms-3 caboutus'>
                                            <li>
                                                Relieving order from the employer<Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                            </li>
                                        </ol>
                                    </ul>


                                    <p className='text-teal caboutus'>
                                        Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                </div>
                            </Fade>}
                        </div>

                        {/*Section*/}

                        <div>
                            {feesOpen && <Fade in={feesOpen}>
                                <div>
                                    <h4 className='mb-4'>Fees and Deposits</h4>
                                    <p className='caboutus'>The applicable tuition and other fee/ deposits for MS (Research) students is available at the following<Link to="/fee-structure" className='c-link'>link</Link>.</p>
                                </div>
                            </Fade>}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && <Fade in={applyonlineOpen}>
                                <div>
                                    <h4 className='mb-4'>Apply Online</h4>
                                    {/* <p><b>To Apply Online</b> : <Link to="#" className='c-link'><b>Will be updated soon..</b></Link> </p> */}
                                    <p><b>To Apply Online</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/msapplication" className='c-link'><b>Click Here</b></Link> </p>
                                    {/* <p><b>To login and download application</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/msapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link>
                                    </p> */}




                                </div>
                            </Fade>}
                        </div>


                    </Col>

                </Row>
            </Container>
        </section>
    );
}

export default Test_Ms_AdmissionELe;
